import { createThemeCompiler } from '../../../utils';

export const calloutThemeCompiler = createThemeCompiler(({ palette, boxShadow, stroke, borderRadius }) => ({
    callout: {
        colors: {
            backgroundColor: palette.white,
            borderColor: palette.neutralLight,
            foregroundColor: palette.black
        },
        composites: {
            borderRaduis: borderRadius.curvedSmall,
            borderWidth: stroke.thin,
            borderStyle: 'solid',
            boxShadow: boxShadow.normal
        }
    }
}));
